
@switch (rowState?.type) {
  @case (rowStateType.Error) {
    <mat-icon [matTooltip]="rowState.message" class="error">
      error
    </mat-icon>
  }
  @case (rowStateType.Warning) {
    <mat-icon [matTooltip]="rowState.message" class="warning">
      warning
    </mat-icon>
  }
}

